import type { Dispatch } from 'redux';
import { createDataActionFactory, Feature, ThunkDispatch } from '../../../shared';
import { restorePersonasOperation } from '../../dataLayer/ows/persona/restorePersonas';
import type { RestoreContactsActionPayload } from '../../actions/user/deletedItems/restoreContactsActions';
import type { ApplyMessageActionResponse } from '../../../service';

export const restoreContactsCompletedAction = createDataActionFactory<
    RestoreContactsActionPayload,
    Error & RestoreContactsActionPayload
>(
    'RestoreContactsCompletedAction',
    Feature.RestoreDeletedContacts,
    action => {
        return {
            itemsInvolved: action.payload.personas.length,
        };
    },
    action => {
        return {
            itemsInvolved: action.payload.personas.length,
        };
    }
);

export function handleRestoreContactsError(
    dispatch: Dispatch,
    error: Error,
    actionPayload: RestoreContactsActionPayload
): void {
    dispatch(restoreContactsCompletedAction.error({ ...error, ...actionPayload }));
}

export const restoreContacts = (payload: RestoreContactsActionPayload) => (
    dispatch: ThunkDispatch
) => {
    const contactIds = payload.personas.map(persona => persona.hubPersonaId);
    restorePersonasOperation(contactIds).then(
        (response: ApplyMessageActionResponse) => {
            dispatch(restoreContactsCompletedAction.success(payload));
        },
        (error: Error) => {
            handleRestoreContactsError(dispatch, Error('Error during Restore contacts'), payload);
        }
    );
};
export type { DataActionFactory } from '../../../shared';
